import { faMoneyCheckDollar } from '@fortawesome/pro-solid-svg-icons'
import { useState } from 'react'
import {
  HeaderActions,
  HeaderIcon,
  HeaderTitle,
  PageHeader
} from '~/components/Layout/Page'
import { InvoiceModal } from '~/domains/finance/components/InvoiceModal'

export const Header = () => {
  const [newInvoiceModalOpen, setNewInvoiceModalOpen] = useState(false)

  return (
    <PageHeader>
      <HeaderTitle>
        <HeaderIcon icon={faMoneyCheckDollar} />
        Facturation
      </HeaderTitle>
      <HeaderActions />
      {newInvoiceModalOpen && (
        <InvoiceModal open onClose={() => setNewInvoiceModalOpen(false)} />
      )}
    </PageHeader>
  )
}
